import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-number-input';
import { formatNumber, isValidNumber as phoneNumberValidator } from 'libphonenumber-js';
import { Form, FormGroup, ControlLabel, FormControl, Modal, Button } from 'react-bootstrap';

import csrfToken from '../../utils/csrfToken';
import styles from './ResendPin.module.scss';

class ResendPin extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false, phoneNumber: props.phoneNumber };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  isPhoneNumberValid() {
    if (!this.state.phoneNumber) { return false; }
    return phoneNumberValidator(this.state.phoneNumber);
  }

  renderModal() {
    return (
      <Form
        horizontal
        className={styles.signup}
        method="post"
        action="/resend_pin"
        onSubmit={this.submitForm}
      >
        <input
          autoComplete="off"
          type="hidden"
          name="authenticity_token"
          value={csrfToken()}
        />
        <input
          autoComplete="off"
          type="hidden"
          name="_method"
          value="patch"
        />
        <input
          autoComplete="off"
          type="hidden"
          name="user[confirmation_token]"
          value={this.props.confirmationToken}
        />
        <input
          autoComplete="off"
          type="hidden"
          name="user[phone_number]"
          value={(this.state.phoneNumber && formatNumber(this.state.phoneNumber, 'International')) || ''}
        />
        <FormGroup
          validationState={this.isPhoneNumberValid() ? 'success' : 'error'}
        >
          <ControlLabel>Phone Number</ControlLabel>
          <FormControl
            country="DE"
            placeholder="+49151123456789"
            componentClass={PhoneInput}
            id="qa-phone"
            value={this.state.phoneNumber}
            onChange={(value) => this.setState({ phoneNumber: value })}
            required
          />
          <FormControl.Feedback />
        </FormGroup>
        <div className="pull-right">
          <Button
            type="submit"
            disabled={!this.isPhoneNumberValid()}
          >
            Resend
          </Button>&nbsp;
          <Button onClick={this.closeModal}>Close</Button>
        </div>
        <div className="clearfix" />
      </Form>
    );
  }

  render() {
    return (
      <div>
        <Button onClick={this.openModal} bsStyle="link">
          Resend Pin
        </Button>
        <Modal
          show={this.state.showModal}
          onHide={this.closeModal}
          dialogClassName={styles.dialog}
        >
          <Modal.Header closeButton className={styles.header}>
            <Modal.Title className={styles.title}>
              Resend Your Pin
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={styles.body}>
            {this.renderModal()}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ResendPin.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  confirmationToken: PropTypes.string.isRequired
};

export default ResendPin;
